// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__EyZq1","list":"BBPicture_list__3vmYb","firstItemBold":"BBPicture_firstItemBold__o8IbX","link":"BBPicture_link__3tmBd"};